import 'react-app-polyfill/ie11';

import dotenv from 'dotenv';
import { Provider } from 'mobx-react';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import App from './App';

import stores from './@stores';
dotenv.config();

const rootEl = document.getElementById('mth-chatbot-app');
if (rootEl) {
  /* eslint-disable-next-line */
  ReactDOM.render(<Provider {...stores} >
    <BrowserRouter basename={process.env.PUBLIC_URL}><App /></BrowserRouter>
  </Provider>, rootEl);
}
